import { type VRNFormatConfig } from '@wrisk/web-app/src/state/configuration'
import React, { ChangeEvent, FunctionComponent, KeyboardEvent, useCallback } from 'react'

import { InputWrapper, InputWrapperProps, TextInput } from '../atoms'
import { formatPartialLicencePlate } from '../extensions'

export interface VehicleRegistrationInputInputProps
  extends Omit<InputWrapperProps, 'onChange' | 'onSubmit'> {
  disabled?: boolean
  value?: string
  onChange: (value: string) => void
  onSubmit?: (value?: string) => void
  placeholder?: string
  vrnFormatConfig: VRNFormatConfig
}

export const VehicleRegistrationInput: FunctionComponent<
  VehicleRegistrationInputInputProps
> = ({
  disabled,
  value,
  onChange,
  placeholder,
  onSubmit,
  name,
  vrnFormatConfig,
  ...props
}) => {
  const onInputChange = useCallback(
    ({ target }: ChangeEvent<HTMLInputElement>) => {
      onChange(formatPartialLicencePlate(vrnFormatConfig)(target.value))
    },
    [onChange],
  )

  const onInputKeyPress = useCallback(
    (event: KeyboardEvent) => {
      if (event.key === 'Enter') {
        event?.preventDefault?.()
        onSubmit?.(value)
      }
    },
    [value, onSubmit],
  )

  return (
    <InputWrapper {...props}>
      <TextInput
        name={name}
        disabled={disabled}
        placeholder={placeholder}
        value={value ?? ''}
        onChange={onInputChange}
        onKeyDown={onInputKeyPress}
        variant='ghost'
        fontFamily='licencePlate'
        width={1}
        typoSize='md'
      />
      {props.children}
    </InputWrapper>
  )
}
